// extracted by mini-css-extract-plugin
export default {"urlJump":"style_urlJump__JYtV0","spinner":"style_spinner__nTGDH"};